'use strict';

import { initSingleModule } from './functions.js';
import AboutHeadModule from './modules/AboutHeadModule.js';
import CardsModule from './modules/CardsModule.js';
import CloudModule from './modules/CloudModule.js';
import Collage1Module from './modules/Collage1Module.js';
import Collage3Module from './modules/Collage3Module.js';
import Collage5Module from './modules/Collage5Module.js';
import FluidImageModule from './modules/FluidImageModule.js';
import FooterModule from './modules/FooterModule.js';
import FormModule from './modules/FormModule.js';
import GsapParallaxModule from './modules/GsapParallaxModule.js';
import HeaderModule from './modules/HeaderModule.js';
import KodensParallaxModule from './modules/KodensParallaxModule.js';
import MainHeroModule from './modules/MainHeroModule.js';
import MainModule from './modules/MainModule.js';
import MenuModule from './modules/MenuModule.js';
import OurApproachModule from './modules/OurApproachModule.js';
import OvalsModule from './modules/OvalsModule.js';
import PageMainModule from './modules/PageMainModule.js';
import PortfolioModule from './modules/PortfolioModule.js';
import ScrollableImageModule from './modules/ScrollableImageModule.js';
import StdAnimationModule from './modules/StdAnimationModule.js';
import TeamModule from './modules/TeamModule.js';
import TechCarouselModule from './modules/TechCarouselModule.js';
import TerrainAnimationModule from './modules/TerrainAnimationModule.js';
import Title3Module from './modules/Title3Module.js';
import CookiesAlertModule from './modules/CookiesAlertModule.js';

window.modules = {
    AboutHeadModule,
    CardsModule,
    CloudModule,
    Collage1Module,
    Collage3Module,
    Collage5Module,
    FluidImageModule,
    FooterModule,
    FormModule,
    GsapParallaxModule,
    HeaderModule,
    KodensParallaxModule,
    MainHeroModule,
    MainModule,
    MenuModule,
    OurApproachModule,
    OvalsModule,
    PageMainModule,
    PortfolioModule,
    ScrollableImageModule,
    StdAnimationModule,
    TeamModule,
    TechCarouselModule,
    TerrainAnimationModule,
    Title3Module,
    CookiesAlertModule,
}

window.addEventListener('load', function() {
    gsap.registerPlugin(ScrollTrigger);
    initAllModules();
});

function initAllModules(rootElement = document) {
    rootElement.querySelectorAll('*[kd-module]').forEach(elm => {
        if (elm.hasAttribute('kd-initted')) {
            return;
        }
        initSingleModule(elm);
    });
}

